import React from 'react';
import PropTypes from 'prop-types';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Container, PageButtons, Button, ChangeButton, Wrapper } from './style';

import { useButtons } from './useButtons';
import Select from 'components/FormElements/Select';

const Pagination = ({
  canPreviousPage,
  canNextPage,
  pageCount,
  gotoPage,
  nextPage,
  previousPage,
  pageSize,
  setPageSize,
  pageIndex,
}) => {
  const buttons = useButtons({ pageCount, pageIndex });

  const handlePageChange = (title) => {
    if (title !== '...') gotoPage(Number(title));
  };

  return (
    <Wrapper>
      <Container>
        <ChangeButton
          color={!canPreviousPage ? '#a8a8a8' : '#080D85'}
          disabled={!canPreviousPage}
          onClick={previousPage}
        >
          <FiChevronLeft size={24} />
        </ChangeButton>
        <PageButtons repeat={pageCount > 7 ? 7 : pageCount}>
          {buttons.map((title, index) => (
            <Button
              key={`${index + 1}`}
              onClick={() => handlePageChange(title)}
              active={pageIndex == title}
            >
              {title !== '...' ? title + 1 : title}
            </Button>
          ))}
        </PageButtons>
        <ChangeButton
          color={!canNextPage ? '#a8a8a8' : '#080D85'}
          disabled={!canNextPage}
          onClick={nextPage}
        >
          <FiChevronRight size={24} />
        </ChangeButton>
      </Container>
    </Wrapper>
  );
};

Pagination.propTypes = {
  pageCount: PropTypes.number,
};
Pagination.defaultProps = {
  pageCount: 40,
};

export default Pagination;
